import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {
  ButtonClassesEnum,
  IButtonModel,
  IconClassesEnum,
} from '@types-custom/models/ui/button-model';
import { GeoApiService } from '@shared/services/geo-api-service/geo-api.service';
import { GeoAPITypeEnum } from '@shared/models/geo-api-type.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ParkingZoneFilterEnum, ParkingStatusFilterEnum, ParkingTypeFilterEnum } from '@shared/models/parking-zone.model';
import { ParkingService } from '@shared/services/layer-service/parking-service/parking.service';
import { forkJoin, map, of } from 'rxjs';
import { MapLayers } from '@shared/utils/mappers/layers-map.model';
import { ParkingLinesEnum } from '@shared/models/parking-line.model';

@Component({
  selector: 'map-filter-parking-square-pmr',
  templateUrl: './map-filter-parking-square-pmr.component.html',
  styleUrls: ['./map-filter-parking-square-pmr.component.scss'],
})
export class MapFilterParkingSquarePmrComponent implements OnInit {

  readonly layer = MapLayers.ParkingSquarePMR;
  readonly DEFAULT_ZONES = [ParkingLinesEnum.GREEN_ZONE, ParkingLinesEnum.BLUE_ZONE];

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    zones: new FormControl(''),
    status: new FormControl(''),
  });

  zoneList: { name: string, value: string }[] = [
    {
      name: 'Disabled',
      value: ParkingZoneFilterEnum.DISABLED_ZONE
    }
  ];

  statusParkingList: { name: string, value: string }[] = [
    {
      name: 'Disponible',
      value: ParkingStatusFilterEnum.Disponible
    },
    {
      name: 'Ocupado',
      value: ParkingStatusFilterEnum.Ocupado
    },
    {
      name: 'Indefinido',
      value: null
    }
  ];

  Icon = Icon;
  buttonTag = 'APLICAR';
  buttonAttributes: IButtonModel = {};
  restorebuttonAttributes: IButtonModel = {};
  applybuttonAttributes: IButtonModel = {};
  createButtonProps: IButtonModel = {
    label: 'APLICAR',
    classAttributes: {
      buttonClass: ButtonClassesEnum.primary_1_button,
      spanClass: IconClassesEnum.text_complementary_2,
    },
  };

  constructor(
    private geoApiService: GeoApiService,
    private parkingService: ParkingService
  ) { }
  ngOnInit() {
    this.generateButtonAttributes();
    this.parkingService.getFilter().subscribe((data) => {
      if (data?.source === this.layer) {
        const filter = data.filters ?? {};
        Object.keys(filter).forEach(k => {
          this.formGroup.get(k)?.patchValue(data.filters[k]);
        });
      }
    });
  }

  private generateButtonAttributes(): void {
    this.buttonAttributes = {
      label: this.buttonTag,
      postIcon: Icon.search_w,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
    this.restorebuttonAttributes = {
      label: 'LIMPIAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.filter_button,
        spanClass: 'text-weight-600 text-size-16 h-150 p-40-px mt-18'
      },
    };
    this.applybuttonAttributes = {
      label: 'BUSCAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
  }

  reloadData(response: any) {
    this.parkingService.linesFilterNotifier$.next(response);
    this.parkingService.setFilter(
      {
        source: this.layer,
        filters: this.formGroup.getRawValue()
      }
    );
    document.querySelector<HTMLElement>('#Filtro').click();
    setTimeout(() => {
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.add('applied-filter');
    }, 10);
  }

  private getFormValues(groupName?: string) {
    const params = groupName
      ? this.formGroup.get(groupName).getRawValue()
      : this.formGroup.getRawValue();
    for (const key in params) {
      if (!params[key]) {
        delete params[key];
      }
    }
    return params;
  }

  private loadData(params: { [key: string]: any }) {
    return forkJoin({
      dataSpots: this.geoApiService.getParkingSquareListFilter(GeoAPITypeEnum.ParkingSquareZones, true, params),
    }).pipe(map(
      resp => {
        const response = {
          baseLayer: this.layer,
          layers: [
            {
              layer: this.layer,
              data: resp.dataSpots,
            },
          ]
        }
        return response;
      }
    ));
  }

  applyFilter() {
    const params = this.getFormValues();
    this.loadData(params).subscribe({
      next: (resp) => {
        this.reloadData(resp);
      },
    });
  }

  cleanFilter() {
    this.formGroup.reset();
    this.parkingService.setFilter(undefined);
    this.loadData({ zones: this.DEFAULT_ZONES })
      .subscribe({
        next: (resp) => {
          this.reloadData(resp);
        },
      })
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.remove('applied-filter');
  }

}
